
import React from 'react';
import { motion } from 'framer-motion';
import { Clock, MapPin, BrainCircuit, ChefHat } from 'lucide-react';
import { Order } from '../../../types';

interface Props {
  order: Order;
}

export const FutureMissionCard: React.FC<Props> = ({ order }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-card-bg/40 border-2 border-dashed border-sal-cyber-teal/30 rounded-3xl p-5 relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 p-3 opacity-10">
        <BrainCircuit className="w-12 h-12 text-sal-cyber-teal" />
      </div>

      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center gap-2">
          <div className="p-1.5 bg-sal-cyber-teal/10 rounded-lg">
            <ChefHat className="w-4 h-4 text-sal-cyber-teal" />
          </div>
          <span className="text-xs font-black text-sal-cyber-teal uppercase tracking-widest">Previsão Sofia</span>
        </div>
        <div className="text-xs font-black text-text-muted uppercase tracking-widest bg-black/5 dark:bg-black/20 px-2 py-1 rounded-full border border-border-dim">
          Cozinha: {order.status === 'ready' ? 'Pronto' : 'Em Preparo'}
        </div>
      </div>

      <h4 className="text-xl font-black text-text-primary uppercase tracking-tight mb-1">{order.customerName.split(' ')[0]}</h4>

      <div className="flex items-center gap-2">
        <MapPin className="w-3 h-3 text-icon-muted" />
        <span className="text-sm font-bold text-text-muted uppercase">{order.neighborhood}</span>
      </div>

      <div className="mt-4 pt-3 border-t border-border-dim flex justify-between items-center">
        <span className="text-xs text-text-muted font-bold uppercase italic">Reservei este para você</span>
        <div className="flex items-center gap-1 text-sal-gold">
          <Clock className="w-3 h-3" />
          <span className="text-xs font-black">SLA OK</span>
        </div>
      </div>
    </motion.div>
  );
};
